<template>
  <section
    v-if="sectionTitle && sectionContent"
    class="how-can-i-help reordered"
  >
    <div>
      <article class="default-text">
        <h2>{{ sectionTitle }}</h2>
        <div v-html="sectionContent" />
      </article>
      <ul>
        <li>
          <svg-hand-first />
          <h3>Nezávislost na jedné instituci</h3>
        </li>
        <li>
          <svg-user-tie />
          <h3>Expertní znalosti a praxe</h3>
        </li>
        <li>
          <svg-hand-holding-box />
          <h3>Osobní přístup a dlouhodobá péče</h3>
        </li>
        <li>
          <svg-gears />
          <h3>Komplexní řešení na míru</h3>
        </li>
        <li>
          <svg-users-line />
          <h3>Spolupráce se silným týmem</h3>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMicrositeStore } from '../../stores/useMicrositeStore'
import SvgHandFirst from "../svg/SvgHandFirst.vue";
import SvgUserTie from "../svg/SvgUserTie.vue";
import SvgHandHoldingBox from "../svg/SvgHandHoldingBox.vue";
import SvgGears from "../svg/SvgGears.vue";
import SvgUsersLine from "../svg/SvgUsersLine.vue";

const store = useMicrositeStore()

const sectionTitle = computed(() => store.microsite?.aboutMePageSection2Title)
const sectionContent = computed(() => store.microsite?.aboutMePageSection2Content)
</script>
